import { mapParamsBySchema, mapRowsBySchema } from './../../util';
import { apiRequest } from '../../Services/Common/ApiRequest';
import Global from '../../Services/Common/Global';
import { Home_Schema } from './Home_Schema';
import useSaveMutation from './../../Hooks/apis/useSaveMutaion';
import useSearchMutaion from './../../Hooks/apis/useSearchMutaion';

export const useSearch1 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(Home_Schema.mapper.search1, context);
    return apiRequest('post', Global.urls.Utility.getDepManager, params);
  }, successOptions);
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(Home_Schema.mapper.search2, context);
    return apiRequest('post', Global.urls.WorkEnd.getWoeBasicR1, params);
  }, successOptions);
};

export const useSave1 = () =>
  useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, Home_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.ToolBoxMeeting.saveTbmNewU2, payload);
  });

export const useSave3 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, Home_Schema.mapper.save3);
    return apiRequest('post1', Global.urls.WorkStop.saveWosBasicU1, payload);
  }, options);
};

export const useSave4 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, Home_Schema.mapper.save4);
    return apiRequest('post1', Global.urls.WorkEnd.saveWoeBasicU1, payload);
  }, options);
};
